import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
  DialogDescription,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Loader2, Save, Tag } from 'lucide-react';

import { useAddBenefitCategoryMutation } from '@/store/benefitCategoryApi';
import { useSelector } from 'react-redux';
import { RootState } from '@/types';
import { toast } from 'sonner';

const AddBenefitCategoryBtn = () => {
  const [Category, setCategory] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const { user } = useSelector((state: RootState) => state.user);
  const [addCategoryFn, { isSuccess, isLoading }] =
    useAddBenefitCategoryMutation();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!Category.trim()) {
      toast.error('Please enter a category name');
      return;
    }
    addCategoryFn({ Token: user?.token, ledger: Category });
  };

  React.useEffect(() => {
    if (isSuccess) {
      toast.success('Benefit Category Added Successfully');
      setCategory('');
      setOpen(false);
    }
  }, [isSuccess]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors flex items-center gap-2 font-medium shadow-sm">
          <Tag className="w-4 h-4" />
          Add Category
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold text-emerald-600">
            <h1>Add New Benefit Category</h1>
          </DialogTitle>
          <DialogDescription>
            Enter the Category details below. Click save when you're done.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-6 pb-4">
            <div className="grid gap-2">
              <Label
                htmlFor="Category"
                className="text-sm font-medium text-muted-foreground"
              >
                Category Name
              </Label>
              <Input
                id="Category"
                value={Category}
                onChange={(e) => setCategory(e.target.value)}
                className="text-foreground"
                placeholder="Enter Category name (e.g., Grant, Sponsorship, Donation)..."
              />
            </div>
          </div>
          <DialogFooter>
            <Button
              type="submit"
              disabled={isLoading}
              className="gap-2 bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              {isLoading ? (
                <Loader2 className="h-4 w-4 animate-spin" />
              ) : (
                <Save className="h-4 w-4" />
              )}
              Save Category
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddBenefitCategoryBtn;
